import { render, staticRenderFns } from "./manualaddscore.vue?vue&type=template&id=39a8f8d5&scoped=true"
import script from "./manualaddscore.vue?vue&type=script&lang=js"
export * from "./manualaddscore.vue?vue&type=script&lang=js"
import style0 from "./manualaddscore.vue?vue&type=style&index=0&id=39a8f8d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a8f8d5",
  null
  
)

export default component.exports